import React from 'react';
import find from 'lodash/find';
import cn from 'classnames';
import { Checkbox } from '@els/els-react--checkbox';
import PropTypes from 'prop-types';
import DialogRow from '@Pages/RetroSynthesis/ExportRoute/components/DialogRow';
import Input from '@Components/Input';

import './ExportOptions.theme.scss';

export const EXPORT_FORM_DESCRIPTION_OPTION = {
  label: 'Include a description in the document',
  name: 'headline',
};

function ExportOptions({ additionalOptions, setSelectedOptions, exportFormDescription, setExportFormDescription }) {
  return (
    <DialogRow label="Additional options:" className="export-options">
      <div className="rx-flex-column-container export-options__container">
        {additionalOptions.map((option) => (
          <Checkbox
            label={option.label}
            key={option.name}
            onChange={(event, value) => {
              setSelectedOptions(additionalOptions.map((o) => ({ ...o, checked: o.name !== option.name ? o.checked : value })));
            }}
            checked={option.checked}
            className={cn('export-options__checkbox', `e2e-export-dialog-option${option.label}`)}
          />
        ))}
        {find(additionalOptions, { name: EXPORT_FORM_DESCRIPTION_OPTION.name, checked: true }) && (
          <Input
            className="export-options__input"
            placeholder="Description"
            animatedPlaceholder
            value={exportFormDescription}
            onChange={setExportFormDescription}
            clearButton={false}
          />
        )}
      </div>
    </DialogRow>
  );
}

export default ExportOptions;

ExportOptions.defaultProps = {
  additionalOptions: [],
};

ExportOptions.propTypes = {
  additionalOptions: PropTypes.array,
  setSelectedOptions: PropTypes.func,
  exportFormDescription: PropTypes.string,
  setExportFormDescription: PropTypes.func,
};
